import {
    initAllSmartFormAddresses,
    initAllSmartFormPostCodes,
    initSmartFormValidation,
    initAllSmartFormCities,
    initSmartFormCountryListeners,
} from "Tools/smartform";

/**
 * Initializes all SmartForm instances on the page
 *
 * This function:
 * 1. Initializes full address autocomplete (street + number) for all address fields
 * 2. Initializes city-only autocomplete for all city fields
 * 3. Initializes post code autocomplete for all post code fields
 * 4. Initializes email and phone validation with jQuery Validate integration
 *
 * Country is auto-detected from data-smartform-target="{group}-country" input fields.
 * Defaults to Slovakia (1) if not found.
 */
const initAllSmartForms = () => {
    // Initialize full address autocomplete (street + house number) for all address fields
    initAllSmartFormAddresses();

    // Initialize post code and city autocomplete
    initAllSmartFormPostCodes();
    initAllSmartFormCities();

    // Initialize email and phone validation
    initSmartFormValidation();

    // Listen for country changes to update SmartForm instances
    initSmartFormCountryListeners();
};

window.initAllSmartForms = initAllSmartForms;
export { initAllSmartForms };
